import { ThreeDotsMenu } from '../../../components/ThreeDotsMenu'
import { AdditionalValuesTableMenuItems } from './MenuItems'
import { TMenuProps } from './types'

export const AdditionalValuesTableMenu = ({ row }: TMenuProps) => {
  return (
    <ThreeDotsMenu className="actual-saving-menu">
      <AdditionalValuesTableMenuItems row={row} />
    </ThreeDotsMenu>
  )
}
